module.exports = __webpack_public_path__ + "static/img/img_logo.eabe6a84.png";